import Api from '../../../../Api';
import { IPagedRequest } from '../../../../shared-interfaces/IPagedRequest';
import { IPagedResponse } from '../../../../shared-interfaces/IPagedResponse';
import { ICategory } from '../../../../shared-interfaces/Notation/ICategory';
import { INotation } from '../../../../shared-interfaces/Notation/INotation';
import { INotationSearchRequest } from '../../../../shared-services/Notation/NotationService';

export interface INotationSearch {
  studentId?: string;
  notationTypes?: string[];
  createdBy?: string;
  createdFor?: string;
  categories: ICategory[];
  startDate?: Date;
  endDate?: Date;
  take?: number;
}

export const NotationManagementService = {
  getNotationsV2: async (
    request: IPagedRequest<INotationSearchRequest>,
  ): Promise<IPagedResponse<INotation>> => {
    if (
      request.searchParameters.categoryIds &&
      !request.searchParameters.categoryIds[0]
    ) {
      request.searchParameters.categoryIds = [];
    }
    const response = await Api.post('management/notation/v2/search', request);
    if (response.status !== 200) throw response.status;
    return {
      ...response.data,
      items: response.data.items.map((x: INotation) => ({
        ...x,
        createdOn: new Date(x.createdOn),
      })),
    };
  },
};
